import { render } from "./coursesActivation.dialog.vue?vue&type=template&id=1eb0a512&ts=true"
import script from "./coursesActivation.dialog.vue?vue&type=script&lang=ts"
export * from "./coursesActivation.dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__